import { render, staticRenderFns } from "./TitleItem.vue?vue&type=template&id=27fea478&scoped=true&"
import script from "./TitleItem.vue?vue&type=script&lang=js&"
export * from "./TitleItem.vue?vue&type=script&lang=js&"
import style0 from "./TitleItem.vue?vue&type=style&index=0&id=27fea478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fea478",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27fea478')) {
      api.createRecord('27fea478', component.options)
    } else {
      api.reload('27fea478', component.options)
    }
    module.hot.accept("./TitleItem.vue?vue&type=template&id=27fea478&scoped=true&", function () {
      api.rerender('27fea478', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/publishGoods/components/TitleItem.vue"
export default component.exports